import axios from "@/utils/axios";

import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useDuplicateFlow = (flowId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      name,
      version_description,
      versioning,
    }: {
      name: string;
      version_description?: string;
      versioning?: boolean;
    }) => {
      const response = await axios.post(`/admin/v1/flows/${flowId}/duplicate`, {
        name,
        version_description,
        versioning,
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["flows"],
      });
      queryClient.invalidateQueries({
        queryKey: ["main-flows"],
      });
    },
    onError: (error) => {
      // Handle error here, e.g., show a notification
      console.error("Error duplicating flow:", error);
    },
  });
};

export const usePerformFlowConnectionsCheck = (flowId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const response = await axios.post(`/admin/v1/flows/${flowId}/check`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["admin-flow-detail", flowId],
      });
    },
  });
};

export const useSendFlowToApproval = (flowId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const response = await axios.post(`/admin/v1/flows/${flowId}/revision`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["admin-flow-detail", flowId],
      });
      queryClient.invalidateQueries({
        queryKey: ["main-flows"],
      });
      queryClient.invalidateQueries({
        queryKey: ["flows"],
      });
    },
  });
};

export const useUpdateFlowRevision = (flowId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: {
      revisionId: string;
      action: "DENIED" | "APPROVED" | "IN_PROCESS";
      comments?: string[];
    }) => {
      const response = await axios.patch(
        `/admin/v1/flows/revision/${params.revisionId}`,
        {
          status: params.action,
          comments: params.comments || [],
        },
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["admin-flow-detail", flowId],
      });
    },
  });
};
